// LoginPage.tsx
import React from "react";
import Login from "../../components/Login/Login";

const LoginPage: React.FC = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
